import { defineComponent as _defineComponent } from 'vue'
import { watch, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { cache, config } from '@/store';
import bookmarkApi from '@/api/bookmark';
import { global_get, global_set_json } from '@/utils';
import i18n from '@/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'right-sidebar',
  props: ['rightSidebar', 'direction', 'removeFirst'],
  emits: [
	'contextMenu',
	'direction',
	'removeFirst',
	'dwonload',
],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { t } = i18n.global;

const route = useRoute();

const drawer = ref(false);

const props = __props;
const emit = __emit;

const removeFirstTitle = computed(() => {
	return props.removeFirst
		? t('option.recoveryFirst')
		: t('option.removeFirst');
});

const bookmarkTitle = computed(() => {
	return config.bookmarkShow
		? t('bookmarkManage.remove')
		: t('bookmarkManage.add');
});

const directionTitle = computed(() => {
	return props.direction ? t('option.rtl') : t('option.ltr');
});

const idDouble = computed(() => {
	return route.name === 'double';
});

const operationText = computed(() => {
	return config.enableOperation ? '关闭操作面板' : '开启操作面板';
})

watch(
	() => config.rightSidebar,
	(val) => {
		drawer.value = val;
	}
);

function close_sidebar() {
	config.rightSidebar = false;
}

function menu_select(key: string) {
	switch (key) {
		case 'bookmark':
			bookmark();
			break;
		case 'direction':
			emit('direction');
			break;
		case 'remove-first':
			emit('removeFirst');
			break;
		case 'dwonload':
			emit('dwonload');
			break;
		case 'operation':
			config.enableOperation = !config.enableOperation;
			break;
	}
	close_sidebar();
}

async function bookmark() {
	if (config.bookmarkShow) {
		await bookmarkApi.delete_and_update(cache.bookmarkId);
	} else {
		// 区分单双页
		let page = Number(global_get('page'));
		
		if (route.name === 'double') {
			page = page * 2 - 1;
		}

		if (route.name === 'half') {
			page = Math.ceil(page / 2);
		}

		await bookmarkApi.add_bookmark(page);
	}
	const res = await bookmarkApi.get_bookmark();

	global_set_json('bookmarkList', res.list);
}

const __returned__ = { t, route, drawer, props, emit, removeFirstTitle, bookmarkTitle, directionTitle, idDouble, operationText, close_sidebar, menu_select, bookmark, get config() { return config } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})